"use client";

import { Chip, Stack } from "@mui/material";

type Props = {
  tags?: string[];
  onRemove: (tag: string) => void;
};

export default function SelectedTagFilters({ tags, onRemove }: Props) {
  if (!tags?.length) return null;

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" useFlexGap aria-label="برچسب‌های انتخاب‌شده">
      {tags.map((tag) => (
        <Chip
          key={tag}
          color="primary"
          variant="outlined"
          label={`#${tag}`}
          onClick={() => onRemove(tag)}
          onDelete={() => onRemove(tag)}
        />
      ))}
    </Stack>
  );
}
